import { render, staticRenderFns } from "./District.vue?vue&type=template&id=71f9e4a4&scoped=true&"
import script from "./District.vue?vue&type=script&lang=js&"
export * from "./District.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9e4a4",
  null
  
)

export default component.exports